__webpack_require__.p = "/ygo_rd_SoloTool_pre/";